export enum ETimeFormat {
  Short = 'short',
  Default = 'default'
}
